import BaseApi from './BaseApi';

class ExclusionGroupService extends BaseApi {
  constructor() {
    super('/exclusion-groups');
  }

  getGroups() {
    return this.get('');
  }

  createGroup(payload) {
    return this.post('', payload);
  }

  updateGroup(groupId, payload) {
    return this.client.put(`/${groupId}`, payload);
  }

  deleteGroup(groupId, payload = {}) {
    return this.client.delete(`/${groupId}`, {
      data: payload,
    });
  }

  getGroupDetail(groupId) {
    return this.get(`/${groupId}`);
  }

  addSymbols(groupId, symbols) {
    return this.post(`/${groupId}/symbols`, { symbols });
  }

  removeSymbols(groupId, symbols) {
    return this.client.delete(`/${groupId}/symbols`, {
      data: { symbols },
    });
  }
}

export default new ExclusionGroupService();
